import { render, staticRenderFns } from "./TrafficTotalCon.vue?vue&type=template&id=39cdff86&scoped=true&"
import script from "./TrafficTotalCon.vue?vue&type=script&lang=js&"
export * from "./TrafficTotalCon.vue?vue&type=script&lang=js&"
import style0 from "./TrafficTotalCon.vue?vue&type=style&index=0&id=39cdff86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cdff86",
  null
  
)

export default component.exports